var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessCircleCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#7CB305"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1154 27.2901C15.2815 27.5097 15.5004 27.6887 15.7541 27.8121C16.0077 27.9356 16.2887 28 16.5739 28C16.859 28 17.1401 27.9356 17.3937 27.8121C17.6474 27.6887 17.8663 27.5097 18.0324 27.2901L29.9147 11.679C30.1291 11.3956 29.9147 11 29.5479 11H26.9018C26.3263 11 25.779 11.262 25.4405 11.7111L16.5767 23.3659L12.5595 18.0838C12.221 17.6401 11.6794 17.3727 11.0982 17.3727H8.45208C8.08535 17.3727 7.87095 17.7684 8.08535 18.0517L15.1154 27.2901Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircleCheck);
export default __webpack_public_path__ + "static/media/success-circle-check.ec2c7a48.svg";
export { ForwardRef as ReactComponent };